import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import AuthPage from '../components/AuthPage';

/**
 * AuthRoute — wrapper page that connects AuthPage to react-router.
 * Shows context-aware copy when user just finished the wizard.
 */
export default function AuthRoute() {
  const { authError } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const hasPending = !!localStorage.getItem('rz_pending_wizard');

  useEffect(() => {
    if (location.state?.from) {
      const fromPath = location.state.from.pathname + (location.state.from.search || '');
      localStorage.setItem('mmr_redirect_after_login', fromPath);
    }
  }, [location]);

  return (
    <div className="page-enter">
      <AuthPage
        authError={authError}
        hasPendingResume={hasPending}
        onBack={() => {
          navigate('/');
        }}
      />
    </div>
  );
}
